/**
 * Message roles for chat completion requests.
 * Values match the `ChatCompletionRole` type used by
 * `ConversationMessageInterface` in the shared library.
 */
export const ChatCompletionRequestMessageRoleEnum = {
    System: 'system',
    User: 'user',
    Assistant: 'assistant',
    Function: 'function'
} as const;
